import { useEffect, useState } from 'react';
import resolveApiBase from '../tradingCockpit/apiBase';

const API_BASE = resolveApiBase();
const API_KEY = process.env.REACT_APP_API_KEY;
const POLL_INTERVAL_MS = 5000;

const resolveUrl = (path) => {
    if (!API_BASE) {
        return path;
    }
    const normalisedBase = API_BASE.endsWith('/') ? API_BASE.slice(0, -1) : API_BASE;
    return `${normalisedBase}${path.startsWith('/') ? path : `/${path}`}`;
};

export function useQCockpitInfra() {
    const [state, setState] = useState({
        infra: null,
        loading: true,
        error: null,
    });

    useEffect(() => {
        let mounted = true;

        const fetchInfra = async () => {
            try {
                const response = await fetch(resolveUrl('/api/qcockpit/infra'), {
                    headers: API_KEY ? { 'x-api-key': API_KEY } : undefined,
                });
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }
                const payload = await response.json();
                if (!mounted) {
                    return;
                }
                setState({
                    infra: payload?.qCockpit || null,
                    loading: false,
                    error: null,
                });
            } catch (error) {
                if (!mounted) {
                    return;
                }
                setState((current) => ({
                    infra: current.infra,
                    loading: false,
                    error,
                }));
            }
        };

        fetchInfra();
        const intervalId = window.setInterval(fetchInfra, POLL_INTERVAL_MS);

        return () => {
            mounted = false;
            window.clearInterval(intervalId);
        };
    }, []);

    return state;
}
